export default "__VITE_ASSET__05f829fe__"